var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSadSearchbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5285 43.7722C70.0507 38.1274 70.1501 32.0165 68.5269 25.9588C64.0111 9.10527 47.7426 -1.43799 30.9032 0.784622C26.2847 1.38051 21.9548 2.89242 18.1013 5.13244C14.1799 7.40361 10.8111 10.3984 8.12543 13.8913C5.39962 17.4278 3.34797 21.5113 2.16225 25.9497C1.01355 30.2221 0.679717 34.7608 1.29064 39.3411C3.48891 56.1966 17.8903 69.1974 35.3487 69.1974C41.5946 69.1974 47.4492 67.5334 52.4937 64.6243C56.491 62.3276 59.918 59.2807 62.6376 55.7207C65.3257 52.2104 67.3514 48.1655 68.5285 43.7722ZM49.7841 59.3212C47.6187 60.5958 45.2465 61.6024 42.7001 62.2847C42.6307 62.3033 42.5625 62.3242 42.4956 62.3473C40.2125 62.9381 37.8176 63.2524 35.3487 63.2524C22.2713 63.2524 11.2704 54.4345 7.96198 42.4148C7.94831 42.3433 7.93194 42.2717 7.91279 42.2003C7.58832 40.9893 7.34707 39.7759 7.18553 38.5659C7.02683 37.3495 6.94497 36.1088 6.94497 34.8487C6.94497 32.196 7.30781 29.6286 7.98663 27.1936C8.97234 23.679 10.6267 20.3892 12.843 17.5094C15.025 14.6803 17.729 12.275 20.8112 10.4368C23.004 9.13365 25.4107 8.10602 27.9972 7.41297C29.2233 7.08444 30.452 6.84122 31.677 6.67968C32.8789 6.52486 34.1044 6.44502 35.3487 6.44502C35.4224 6.44502 35.4954 6.44234 35.5678 6.43707C48.0346 6.5214 59.3998 14.8654 62.7845 27.4974C63.4234 29.8818 63.7397 32.276 63.76 34.6338C63.755 34.7048 63.7524 34.7765 63.7524 34.8487C63.7524 37.5108 63.387 40.0869 62.7036 42.5295C61.7273 45.9982 60.0995 49.2473 57.923 52.0987C55.7052 54.9978 52.9412 57.4563 49.7841 59.3212Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3201 60.8201C62.481 59.6593 64.363 59.6593 65.5239 60.8201L72.1294 67.4256C73.2902 68.5864 73.2902 70.4685 72.1294 71.6293C70.9686 72.7901 69.0865 72.7901 67.9257 71.6293L61.3201 65.0238C60.1593 63.863 60.1593 61.9809 61.3201 60.8201Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 25C28.3807 25 29.5 26.1193 29.5 27.5V32.5H24.5V27.5C24.5 26.1193 25.6193 25 27 25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 25C44.3807 25 45.5 26.1193 45.5 27.5V32.5H40.5V27.5C40.5 26.1193 41.6193 25 43 25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 42.5C32.2386 42.5 30 44.7386 30 47.5H26C26 42.5294 30.0294 38.5 35 38.5C39.9706 38.5 44 42.5294 44 47.5H40C40 44.7386 37.7614 42.5 35 42.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadSearchbar);
export default __webpack_public_path__ + "static/media/sadSearchbar.ade77296.svg";
export { ForwardRef as ReactComponent };